export default "__VITE_ASSET__4NDajBGB__"